export default __webpack_public_path__ + "static/people-0131afb3912fcd1c92624ba2d7fece87.png";